export class CostPlus {
  id!: number;
  value!: number;
  enabled!: boolean;
}
